import styled from "@emotion/styled"
import { Grid } from "@mui/material"

export const StyledFilterGrid = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  "@media (min-width: 992px)": {
    flexDirection: "row"
  },
  "& > div:nth-child(1)": {
    flexGrow: 1
  },
  "& > div:nth-child(2)": {
    display: "flex",
    marginTop: "6px",
    "@media (min-width: 992px)": {
      justifyContent: "flex-end",
      marginTop: 0
    }
  }
})
